import { useRef, useState } from "react";
import { Loader2, Mic, Square } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const AudioRecorder = ({ onUploaded }) => {
  const [rec, setRec] = useState(null);
  const [busy, setBusy] = useState(false);
  const [secs, setSecs] = useState(0);
  const chunks = useRef([]);
  const timer = useRef(null);
  if (typeof window === "undefined" || !window.MediaRecorder || !navigator.mediaDevices?.getUserMedia) return null;

  const upload = async (blob) => {
    setBusy(true);
    try {
      const ext = blob.type.includes("mp4") ? "m4a" : blob.type.includes("ogg") ? "ogg" : "webm";
      const fd = new FormData();
      fd.append("file", new File([blob], `gravacao-ruido.${ext}`, { type: blob.type.split(";")[0] || "audio/webm" }));
      const { data } = await api.post("/uploads", fd);
      onUploaded(data);
      toast.success("Gravação anexada");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      mr.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
      mr.onstop = () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunks.current, { type: mr.mimeType || "audio/webm" });
        chunks.current = [];
        upload(blob);
      };
      mr.start();
      setRec(mr);
      setSecs(0);
      timer.current = setInterval(() => setSecs((s) => s + 1), 1000);
    } catch {
      toast.error("Não foi possível acessar o microfone. Verifique a permissão do navegador.");
    }
  };
  const stop = () => { clearInterval(timer.current); rec?.stop(); setRec(null); };

  return (
    <button type="button" onClick={rec ? stop : start} disabled={busy} data-testid="dr-record-audio"
      className={`mb-3 flex w-full items-center justify-center gap-2 border px-4 py-3 text-sm transition-colors ${rec ? "border-red-600 bg-red-600 text-white" : "border-slate-600 bg-black/30 text-slate-200 hover:border-red-500"}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : rec ? <Square className="h-4 w-4" /> : <Mic className="h-4 w-4 text-red-500" />}
      {busy ? "Enviando gravação..." : rec ? `Parar gravação (${secs}s)` : "Gravar o ruído agora"}
    </button>
  );
};
